export default __webpack_public_path__ + "static/media/right-mountains2.bbc96304.svg";